import useSWR from 'swr/immutable';
import { useIntl } from 'react-intl';

import type { UspData, UspRootItem } from './types';
import { getUspDataEndpoint, useUspCacheKey } from './getUspData';

const fetcher = (endpoint: string) => (): Promise<UspData> =>
  fetch(endpoint).then((res) => {
    if (!res.ok) {
      // throw error when response status not ok -> error boundary catches and logs the error
      throw new Error(`Endpoint: ${res.url} - Status ${res.status}: ${res.statusText}`);
    }
    return res.json();
  });

const mapData = (uspItem: UspRootItem) => ({
  ...uspItem,
  children: Object.values(uspItem.children).filter(Boolean),
});

export const useUspData = (): { data: UspData | undefined; endpoint: string } => {
  const { locale } = useIntl();
  const endpoint = getUspDataEndpoint(locale);
  const uspCacheKey = useUspCacheKey();
  const { data } = useSWR<UspData>(uspCacheKey, fetcher(endpoint));

  return { data: data ? [mapData(data['0']), mapData(data['1'])] : undefined, endpoint };
};
